import { throttle } from 'lodash';

export function header() {
	window.addEventListener('scroll', _.throttle(scrollHeader, 100));
}

function scrollHeader() {
	const headerEle = document.querySelector('.js-header');
	const pageTop = window.pageYOffset;

	if (pageTop > 0) {
		headerEle.classList.add('is-scroll');
	} else {
		headerEle.classList.remove('is-scroll');
	}
}
